/**
 * pcn-forms-tracking.js — Puente de tracking para Shopify Forms (embeds).
 *
 * Problema: el embed <shopify-forms-embed> envía por fetch interno dentro de
 * su shadow DOM, sin <form action> nativo. Ni el Pixel de Meta del theme
 * (fbq) ni los web pixels de Customer Events se enteran del envío — Shopify
 * Forms no emite form_submitted (limitación conocida del app). Los botones
 * nativos del theme sí trackean porque disparan fbq directo.
 *
 * Solución: detectar el envío exitoso desde la página padre y disparar:
 *   - fbq('track', 'Lead')                       -> Pixel(es) de Meta del theme
 *   - Shopify.analytics.publish('pcn_forms_lead') -> disponible para pixels
 *     custom de Customer Events (GA4 u otros), por si se quieren enganchar.
 *
 * Detector: hook de fetch/XHR — POST a .../form_submission con respuesta OK.
 * El código del app resuelve fetch global en el momento del envío (verificado
 * en su bundle: `return fetch(e,u)`), así que el hook lo intercepta aunque
 * este script cargue con defer. Se descartó un observer del shadow DOM como
 * respaldo: el app desmonta el <form> también al cerrar popups y re-impone
 * estilos del host, lo que generaba Leads falsos. Mejor perder la señal si
 * Forms cambia de transporte (fail-closed) que contar leads que no existen.
 */
(function () {
  'use strict';

  if (window.__pcnFormsTracking) return;
  window.__pcnFormsTracking = true;

  // Debug opcional por consola: agregar ?pcn_debug=1 a la URL, o dejarlo fijo
  // con localStorage.setItem('pcn_debug', '1') (se apaga con removeItem).
  // En producción normal no imprime nada.
  var DEBUG = false;
  try {
    DEBUG = /[?&]pcn_debug=1/.test(window.location.search) || window.localStorage.getItem('pcn_debug') === '1';
  } catch (e) { /* sin storage (modo privado): solo queda el query param */ }

  function log(mensaje, extra) {
    if (!DEBUG) return;
    try { console.info('[pcn-forms-tracking] ' + mensaje, extra || ''); } catch (e) { /* consola bloqueada */ }
  }

  // Solo el envío real: forms.shopifyapps.com/api/vN/form_submission.
  // OJO: el embed también hace POST a /spans (telemetría), /customer y a la
  // subida de archivos en el mismo host — no son envíos y no deben contar.
  var ES_SUBMIT = /forms\.shopifyapps\.com\/.*form_submission/i;
  var ultimoLead = 0;

  function fireLead() {
    var ahora = Date.now();
    if (ahora - ultimoLead < 10000) { log('señal repetida en menos de 10s — ignorada (dedupe)'); return; }
    ultimoLead = ahora;
    try {
      if (typeof window.fbq === 'function') {
        window.fbq('track', 'Lead', { content_name: 'Shopify Forms', content_category: window.location.pathname });
        log('fbq("track", "Lead") enviado a Meta', window.location.pathname);
      } else {
        log('OJO: window.fbq no existe en esta página — el Lead NO llegó a Meta');
      }
    } catch (e) { /* nunca romper la página por tracking */ }
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish('pcn_forms_lead', { path: window.location.pathname });
        log('evento pcn_forms_lead publicado a Shopify.analytics');
      }
    } catch (e) { /* idem */ }
  }

  /* ── Detector: red (fetch + XHR) ───────────────────────────────────── */

  var fetchOriginal = window.fetch;
  if (typeof fetchOriginal === 'function') {
    window.fetch = function (entrada, opciones) {
      var url = '';
      var metodo = 'GET';
      try {
        url = typeof entrada === 'string' ? entrada : (entrada && entrada.url) || '';
        metodo = (opciones && opciones.method) || (entrada && entrada.method) || 'GET';
      } catch (e) { /* no bloquear el fetch por inspección fallida */ }
      var promesa = fetchOriginal.apply(this, arguments);
      if (ES_SUBMIT.test(url) && /post/i.test(metodo)) {
        log('envío de Shopify Forms detectado (fetch)', url);
        promesa.then(function (res) {
          if (res && res.ok) fireLead();
          else log('el envío respondió con error — sin Lead', res && res.status);
        }).catch(function () { log('el envío falló a nivel de red — sin Lead'); });
      }
      return promesa;
    };
  }

  var abrirXhr = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (metodo, url) {
    try { this.__pcnLead = ES_SUBMIT.test(String(url)) && /post/i.test(String(metodo)); } catch (e) { this.__pcnLead = false; }
    return abrirXhr.apply(this, arguments);
  };
  var enviarXhr = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    if (this.__pcnLead) {
      log('envío de Shopify Forms detectado (XHR)');
      this.addEventListener('load', function () {
        if (this.status >= 200 && this.status < 300) fireLead();
        else log('el envío (XHR) respondió con error — sin Lead', this.status);
      });
    }
    return enviarXhr.apply(this, arguments);
  };

  log('activo — vigilando envíos de Shopify Forms en ' + window.location.pathname);
})();
